'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '__THEMING__';


//////////////////
// WEBPACK FOOTER
// ./~/theming/dist/cjs/channel.js
// module id = 353
// module chunks = 231608221292675